import { useQuery } from "@tanstack/react-query"
import { companyQuery } from "../lib/companyQuery"

export function useCompanyQuery(...args: Parameters<typeof companyQuery>) {
  return useQuery(companyQuery(...args))
}
